export const PAGE_IDS = [
  "overview",
  "review",
  "active",
  "workflows",
  "discover",
  "memory",
  "graph",
  "wiki",
  "library",
  "curator",
  "packs",
  "agents",
  "activity",
  "settings",
] as const;

export type PageId = typeof PAGE_IDS[number];

export interface AppRoute {
  page: PageId;
  wikiNoteId?: string;
}

const PAGE_ID_SET = new Set<string>(PAGE_IDS);

function safeDecodedNoteId(value: string | undefined): string | undefined {
  if (!value) return undefined;
  try {
    const decoded = decodeURIComponent(value).trim();
    if (!decoded || decoded.length > 240 || [...decoded].some((character) => {
      const code = character.charCodeAt(0);
      return code <= 31 || code === 127;
    })) return undefined;
    return decoded;
  } catch {
    return undefined;
  }
}

export function parseAppRoute(hash: string): AppRoute {
  const path = hash.replace(/^#\/?/, "");
  const [candidate, ...rest] = path.split("/");
  const page = PAGE_ID_SET.has(candidate) ? candidate as PageId : "overview";
  return {
    page,
    wikiNoteId: page === "wiki" ? safeDecodedNoteId(rest.join("/")) : undefined,
  };
}

export function appRouteHash(page: PageId, wikiNoteId?: string): string {
  if (page === "wiki" && wikiNoteId) return `#/wiki/${encodeURIComponent(wikiNoteId)}`;
  return `#/${page}`;
}
